let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5GyZj")).then(() => parcelRequire('787ZT'));